const handleProducts = (products, category) => {
				switch (category) {
					case 'collection':
					case 'single':
					case 'multi_single':
							return products.filter((item) => (item.type === category));

					case 'master':
							return products.filter((item) => (item.category === '3'));

					case 'lab-kit':
							return products.filter((item) => (item.category === '1'));

					default:
							return products;
				}
		},
		handleTags = (products) => {
				let tags = [];

				for (let i = 0; i < products.length; i++) {
						if (products[i].tags.length) {
								for (let j = 0; j < products[i].tags.length; j++) {
										let tag = products[i].tags[j].name;

										if (tags.indexOf(tag) < 0) {
												tags[tags.length] = tag;
										}
								}
						}
				}

				return tags;
		}


export { handleProducts, handleTags }
